function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tablemouse
 */
import { Plugin } from 'ckeditor5/src/core';
import TableSelection from './tableselection';
import MouseEventsObserver from './tablemouse/mouseeventsobserver';
import { getTableCellsContainingSelection } from './utils/selection';
/**
 * This plugin enables a table cells' selection with the mouse.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableMouse = /*#__PURE__*/function (_Plugin) {
  _inherits(TableMouse, _Plugin);

  var _super = _createSuper(TableMouse);

  function TableMouse() {
    _classCallCheck(this, TableMouse);

    return _super.apply(this, arguments);
  }

  _createClass(TableMouse, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor; // Currently the MouseObserver only handles `mousedown` and `mouseup` events.
      // TODO move to the engine?

      editor.editing.view.addObserver(MouseEventsObserver);

      this._enableShiftClickSelection();

      this._enableMouseDragSelection();
    }
    /**
     * Enables making cells selection by <kbd>Shift</kbd>+click. Creates a selection from the cell which previously held
     * the selection to the cell which was clicked. It can be the same cell, in which case it selects a single cell.
     *
     * @private
     */

  }, {
    key: "_enableShiftClickSelection",
    value: function _enableShiftClickSelection() {
      var _this = this;

      var editor = this.editor;
      var blockSelectionChange = false;
      var tableSelection = editor.plugins.get(TableSelection);
      this.listenTo(editor.editing.view.document, 'mousedown', function (evt, domEventData) {
        if (!_this.isEnabled || !tableSelection.isEnabled) {
          return;
        }

        if (!domEventData.domEvent.shiftKey) {
          return;
        }

        var anchorCell = tableSelection.getAnchorCell() || getTableCellsContainingSelection(editor.model.document.selection)[0];

        if (!anchorCell) {
          return;
        }

        var targetCell = _this._getModelTableCellFromDomEvent(domEventData);

        if (targetCell && haveSameTableParent(anchorCell, targetCell)) {
          blockSelectionChange = true;
          tableSelection.setCellSelection(anchorCell, targetCell);
          domEventData.preventDefault();
        }
      });
      this.listenTo(editor.editing.view.document, 'mouseup', function () {
        blockSelectionChange = false;
      }); // We need to ignore a `selectionChange` event that is fired after we render our new table cells selection.
      // When downcasting table cells selection to the view, we put the view selection in the last selected cell
      // in a place that may not be natively a "correct" location. This is – we put it directly in the `<td>` element.
      // All browsers fire the native `selectionchange` event.
      // However, all browsers except Safari return the selection in the exact place where we put it
      // (even though it's visually normalized). Safari returns `<td><p>^foo` that makes our selection observer
      // fire our `selectionChange` event (because the view selection that we set in the first step differs from the DOM selection).
      // Since `selectionChange` is fired, we automatically update the model selection that moves it that paragraph.
      // This breaks our dear cells selection.
      //
      // Theoretically this issue concerns only Safari that is the only browser that do normalize the selection.
      // However, to avoid code branching and to have a good coverage for this event blocker, I enabled it for all browsers.
      //
      // Note: I'm keeping the `blockSelectionChange` state separately for shift+click and mouse drag (exact same logic)
      // so I don't have to try to analyze whether they don't overlap in some weird cases. Probably they don't.
      // But I have other things to do, like writing this comment.

      this.listenTo(editor.editing.view.document, 'selectionChange', function (evt) {
        if (blockSelectionChange) {
          // @if CK_DEBUG // console.log( 'Blocked selectionChange to avoid breaking table cells selection.' );
          evt.stop();
        }
      }, {
        priority: 'highest'
      });
    }
    /**
     * Enables making cells selection by dragging.
     *
     * The selection is made only on mousemove. Mouse tracking is started on mousedown.
     * However, the cells selection is enabled only after the mouse cursor left the anchor cell.
     * Thanks to that normal text selection within one cell works just fine. However, you can still select
     * just one cell by leaving the anchor cell and moving back to it.
     *
     * @private
     */

  }, {
    key: "_enableMouseDragSelection",
    value: function _enableMouseDragSelection() {
      var _this2 = this;

      var editor = this.editor;
      var anchorCell, targetCell;
      var beganCellSelection = false;
      var blockSelectionChange = false;
      var tableSelection = editor.plugins.get(TableSelection);
      this.listenTo(editor.editing.view.document, 'mousedown', function (evt, domEventData) {
        if (!_this2.isEnabled || !tableSelection.isEnabled) {
          return;
        } // Make sure to not conflict with the shift+click listener and any other possible handler.


        if (domEventData.domEvent.shiftKey || domEventData.domEvent.ctrlKey || domEventData.domEvent.altKey) {
          return;
        }

        anchorCell = _this2._getModelTableCellFromDomEvent(domEventData);
      });
      this.listenTo(editor.editing.view.document, 'mousemove', function (evt, domEventData) {
        if (!domEventData.domEvent.buttons) {
          return;
        }

        if (!anchorCell) {
          return;
        }

        var newTargetCell = _this2._getModelTableCellFromDomEvent(domEventData);

        if (newTargetCell && haveSameTableParent(anchorCell, newTargetCell)) {
          targetCell = newTargetCell; // Switch to the cell selection mode after the mouse cursor left the anchor cell.
          // Switch off only on mouseup (makes selecting a single cell possible).

          if (!beganCellSelection && targetCell != anchorCell) {
            beganCellSelection = true;
          }
        } // Yep, not making a cell selection yet. See method docs.


        if (!beganCellSelection) {
          return;
        }

        blockSelectionChange = true;
        tableSelection.setCellSelection(anchorCell, targetCell);
        domEventData.preventDefault();
      });
      this.listenTo(editor.editing.view.document, 'mouseup', function () {
        beganCellSelection = false;
        blockSelectionChange = false;
        anchorCell = null;
        targetCell = null;
      }); // See the explanation in `_enableShiftClickSelection()`.

      this.listenTo(editor.editing.view.document, 'selectionChange', function (evt) {
        if (blockSelectionChange) {
          // @if CK_DEBUG // console.log( 'Blocked selectionChange to avoid breaking table cells selection.' );
          evt.stop();
        }
      }, {
        priority: 'highest'
      });
    }
    /**
     * Returns the model table cell element based on the target element of the passed DOM event.
     *
     * @private
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     * @returns {module:engine/model/element~Element|undefined} Returns the table cell or `undefined`.
     */

  }, {
    key: "_getModelTableCellFromDomEvent",
    value: function _getModelTableCellFromDomEvent(domEventData) {
      // Note: Work with positions (not element mapping) because the target element can be an attribute or other non-mapped element.
      var viewTargetElement = domEventData.target;
      var viewPosition = this.editor.editing.view.createPositionAt(viewTargetElement, 0);
      var modelPosition = this.editor.editing.mapper.toModelPosition(viewPosition);
      var modelElement = modelPosition.parent;
      return modelElement.findAncestor('tableCell', {
        includeSelf: true
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableMouse';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableSelection];
    }
  }]);

  return TableMouse;
}(Plugin);

export { TableMouse as default };

function haveSameTableParent(cellA, cellB) {
  return cellA.parent.parent == cellB.parent.parent;
}